<template>
  
  <div>
    <v-row no-gutters class="flex-column" v-if="intake">
      <v-col>
        
        <v-simple-table dense>
          <template v-slot:default>
            <thead :class="{'grey lighten-2': summary, 'primary': !summary}" v-if="wealthTransfers.data.length">
              <tr>
                <th colspan="5">
                  <v-row no-gutters class="align-center">
                    <v-col :class="{'grey--text text--darken-1': summary, 'white--text': !summary}">Wealth Transfers</v-col>
                    <v-col class="text-right" :class="{'grey--text text--darken-1': summary, 'white--text': !summary}">{{ wealthTransfers.total | currencyRounded }}</v-col>
                  </v-row>
                </th>
              </tr>
            </thead>
            <thead class="grey lighten-4" v-if="wealthTransfers.data.length && !summary">
              <tr>
                <th colspan="2">Type</th>
                <th class="text-right" style="width: 180px;">Min. Payment</th>
                <th class="text-right" style="width: 200px;">Actual Payment</th>
                <th class="text-right primary--text" style="width: 120px;">PCO</th>
              </tr>
            </thead>
            <tbody v-if="wealthTransfers.total && !summary">
              <tr
                v-for="debt in wealthTransfers.data"
                :key="'wtDebt-' + debt.id"
              >
                <td colspan="2"><v-btn text disabled style="min-width: 0px; width: 29.75px;" class="mr-2"></v-btn>{{ debt.type.charAt(0).toUpperCase() + debt.type.substring(1) }}</td>
                <td class="text-right">{{ debt.minimum_payment | currencyRounded }}</td>
                <td class="text-right">{{ debt.actual_payment | currencyRounded }}</td>
                <td class="text-right primary--text">{{ (debt.actual_payment - debt.minimum_payment) | currencyRounded }}</td>
              </tr>
            </tbody>
            
            <thead :class="{'grey lighten-2': summary, 'primary': !summary}" v-if="lifeInsurances.data.length">
              <tr>
                <th colspan="5">
                  <v-row no-gutters class="align-center">
                    <v-col class="py-1" :class="{'grey--text text--darken-1': summary, 'white--text': !summary}">Life Insurance</v-col>
                    <v-col class="text-right" :class="{'grey--text text--darken-1': summary, 'white--text': !summary}">{{ lifeInsurances.total | currencyRounded }}</v-col>
                  </v-row>
                </th>
              </tr>
            </thead>
            <thead class="grey lighten-4"  v-if="lifeInsurances.data.length && !summary">
              <tr>
                <th>Owner</th>
                <th>Ins. Company</th>
                <th class="text-right">Monthly Premium</th>
                <th class="text-right">1035 Exchange</th>
                <th class="text-right primary--text">PCO</th>
              </tr>
            </thead>
            <tbody v-if="lifeInsurances.data.length && !summary">
              <tr
                v-for="(li, liIndex) in lifeInsurances.data"
                :key="'liPolicy-' + liIndex"
              >
                <td>
                  <v-tooltip top v-if="!li.exclude">
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" x-small text color="error" style="min-width: 0px;" class="mr-2" @click="setExclude('insurance', li.id, true)"><v-icon x-small>mdi-minus</v-icon></v-btn>
                    </template>
                    <span>
                      Exclude
                    </span>
                  </v-tooltip>
                  <v-tooltip top v-else>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" x-small color="primary" style="min-width: 0px;" class="mr-2" @click="setExclude('insurance', li.id, false)"><v-icon x-small>mdi-plus</v-icon></v-btn>
                    </template>
                    <span>
                      Include
                    </span>
                  </v-tooltip>
                  <span :class="{'error--text text-decoration-line-through': li.exclude}">{{ li.owner.first_name }}</span>
                </td>
                <td :class="{'error--text text-decoration-line-through': li.exclude}">{{ li.company }}</td>
                <td class="text-right" :class="{'error--text text-decoration-line-through': li.exclude}">{{ li.monthly_premium | currencyRounded }}</td>
                <td class="text-right" :class="{'error--text text-decoration-line-through': li.exclude}">{{ (li.type == 'cash' ? li.cash_value : 0) | currencyRounded }}</td>
                <td class="text-right primary--text" :class="{'error--text text-decoration-line-through': li.exclude}">{{ li.monthly_premium | currencyRounded }}</td>
              </tr>
            </tbody>


            <thead :class="{'grey lighten-2': summary, 'primary': !summary}" v-if="retirementAccounts.data.length">
              <tr>
                <th colspan="5">
                  <v-row no-gutters class="align-center">
                    <v-col class="py-1" :class="{'grey--text text--darken-1': summary, 'white--text': !summary}">Retirement Accounts</v-col>
                    <v-col class="text-right" :class="{'grey--text text--darken-1': summary, 'white--text': !summary}">{{ retirementAccounts.total | currencyRounded }}</v-col>
                  </v-row>
                </th>
              </tr>
            </thead>
            <thead class="grey lighten-4"  v-if="retirementAccounts.data.length && !summary">
              <tr>
                <th>Owner</th>
                <th colspan="2">Type</th>
                <th class="text-right">Unmatched Contributions</th>
                <th class="text-right primary--text">PCO</th>
              </tr>
            </thead>
            <tbody v-if="retirementAccounts.data.length && !summary">
              <tr
                v-for="(ra, raIndex) in retirementAccounts.data"
                :key="'ra-' + raIndex"
              >
                <td>
                  <v-tooltip top v-if="!ra.exclude">
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" x-small text color="error" style="min-width: 0px;" class="mr-2" @click="setExclude('retirement', ra.id, true)"><v-icon x-small>mdi-minus</v-icon></v-btn>
                    </template>
                    <span>
                      Exclude
                    </span>
                  </v-tooltip>
                  <v-tooltip top v-else>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" x-small color="primary" style="min-width: 0px;" class="mr-2" @click="setExclude('retirement', ra.id, false)"><v-icon x-small>mdi-plus</v-icon></v-btn>
                    </template>
                    <span>
                      Include
                    </span>
                  </v-tooltip>
                  <span :class="{'error--text text-decoration-line-through': ra.exclude}">{{ ra.owner.first_name }}</span>
                </td>
                <td colspan="2" :class="{'error--text text-decoration-line-through': ra.exclude}">
                  <span v-if="ra.type == '401k'">401k</span>
                  <span v-if="ra.type == 'roth'">Roth IRA</span>
                  <span v-if="ra.type == 'ira'">IRA</span>
                </td>
                <td class="text-right" :class="{'error--text text-decoration-line-through': ra.exclude}">{{ ra.unmatched_contribution | currencyRounded }}</td>
                <td class="text-right primary--text" :class="{'error--text text-decoration-line-through': ra.exclude}">{{ ra.unmatched_contribution | currencyRounded }}</td>
              </tr>
            </tbody>


            <thead :class="{'grey lighten-2': summary, 'primary': !summary}" v-if="savingsAccounts.data.length">
              <tr>
                <th colspan="5">
                  <v-row no-gutters class="align-center">
                    <v-col class="py-1" :class="{'grey--text text--darken-1': summary, 'white--text': !summary}">Savings Accounts</v-col>
                    <v-col class="text-right" :class="{'grey--text text--darken-1': summary, 'white--text': !summary}">{{ savingsAccounts.total | currencyRounded }}</v-col>
                  </v-row>
                </th>
              </tr>
            </thead>
            <thead class="grey lighten-4" v-if="savingsAccounts.data.length && !summary">
              <tr>
                <th>Owner</th>
                <th colspan="2">Type</th>
                <th class="text-right">Monthly Contribution</th>
                <th class="text-right primary--text">PCO</th>
              </tr>
            </thead>
            <tbody v-if="savingsAccounts.data.length && !summary">
              <tr
                v-for="(sa, saIndex) in savingsAccounts.data"
                :key="'sa-' + saIndex"
              >
                <td>
                  <v-tooltip top v-if="!sa.exclude">
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" x-small text color="error" style="min-width: 0px;" class="mr-2" @click="setExclude('savings', sa.id, true)"><v-icon x-small>mdi-minus</v-icon></v-btn>
                    </template>
                    <span>
                      Exclude
                    </span>
                  </v-tooltip>
                  <v-tooltip top v-else>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" x-small color="primary" style="min-width: 0px;" class="mr-2" @click="setExclude('savings', sa.id, false)"><v-icon x-small>mdi-plus</v-icon></v-btn>
                    </template>
                    <span>
                      Include
                    </span>
                  </v-tooltip>
                  <span :class="{'error--text text-decoration-line-through': sa.exclude}">{{ sa.owner.first_name }}</span>
                </td>
                <td colspan="2" :class="{'error--text text-decoration-line-through': sa.exclude}">
                  <span v-if="sa.type == 'savings'">Savings</span>
                  <span v-if="sa.type == 'cd'">C.D.</span>
                </td>
                <td class="text-right" :class="{'error--text text-decoration-line-through': sa.exclude}">{{ sa.monthly_contribution | currencyRounded }}</td>
                <td class="text-right primary--text" :class="{'error--text text-decoration-line-through': sa.exclude}">{{ sa.monthly_contribution | currencyRounded }}</td>
              </tr>
            </tbody>


            <thead class="primary">
              <tr>
                <th colspan="5" class="summaryFooter">
                  <v-row no-gutters>
                    <v-col class="white--text title">
                      Potential Capital Optimization
                    </v-col>
                    <v-col class="white--text text-right title">
                      {{ poc | currencyRounded }}
                    </v-col>
                  </v-row>
                </th>
              </tr>
            </thead>

            <thead>
              <tr><th colspan="5" style="height: 50px;"></th></tr>
            </thead>

            <!--<thead class="grey lighten-4">
              <tr>
                <th colspan="5" class="text-left">
                  Discretionary Income
                </th>
              </tr>
            </thead>-->
            <thead class="grey lighten-4" v-if="primaryIncomeData.length">
              <tr>
                <th colspan="5" class="text-left">
                  Primary Income
                </th>
              </tr>
            </thead>
            <tbody v-if="primaryIncomeData.length">
              <tr
                v-for="(di, diIndex) in primaryIncomeData"
                :key="'pid-' + diIndex"
              >
                <td colspan="4">
                  <span>{{ di.label }}</span>
                </td>
                <td class="text-right primary--text">{{ di.amount | currencyRounded }}</td>
              </tr>
            </tbody>
            <thead class="grey lighten-4" v-if="additionalIncomeData.length">
              <tr>
                <th colspan="5" class="text-left">
                  Additional Income
                </th>
              </tr>
            </thead>
            <tbody v-if="additionalIncomeData.length">
              <tr
                v-for="(di, diIndex) in additionalIncomeData"
                :key="'aid-' + diIndex"
              >
                <td colspan="4">
                  <span>{{ di.label }}</span>
                </td>
                <td class="text-right primary--text">{{ di.amount | currencyRounded }}</td>
              </tr>
            </tbody>
            <thead class="grey lighten-4">
              <tr>
                <th colspan="5" class="text-left">
                  Outgoing
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="4">Wealth Transfer Minimum Payments</td>
                <td class="text-right error--text">{{ wealthTransfers.totalMin | currencyRounded }}</td>
              </tr>
              <tr>
                <td colspan="4">Potential Capital Optimization</td>
                <td class="text-right error--text">{{ poc | currencyRounded }}</td>
              </tr>
            </tbody>

            <thead class="primary">
              <tr>
                <th colspan="5" class="summaryFooter">
                  <v-row no-gutters>
                    <v-col class="white--text title">
                      Discretionary Income
                    </v-col>
                    <v-col class="white--text text-right title">
                      {{ discretionaryIncome | currencyRounded }}
                    </v-col>
                  </v-row>
                </th>
              </tr>
            </thead>

          </template>
        </v-simple-table>
      </v-col>
      <v-col class="text-center mt-6" v-if="!summary">
        <v-btn text color="grey" :disabled="saving" @click="dontSave" class="mr-2">Don't Save</v-btn>
        <v-btn text color="grey" :loading="saving" @click="saveIntake" class="ml-2">Save & Close</v-btn>
      </v-col>
    </v-row>
  </div>

</template>

<script>
export default {
  name: 'IntakeSummary',
  props: {
    household: {
      type: Object,
      required: true
    },
    summary: Boolean
  },
  data () {
    return {
      saving: false,
      intake: null
    }
  },
  mounted () {
    this.intake = JSON.parse(JSON.stringify(this.household.intake))
  },
  watch: {
    household: {
      handler (newVal) {
        this.intake = JSON.parse(JSON.stringify(newVal.intake))
      },
      deep: true
    }
  },
  computed: {
    poc () {
      return (this.wealthTransfers.total + this.lifeInsurances.total + this.retirementAccounts.total + this.savingsAccounts.total)
    },
    discretionaryIncome() {
      let total = 0
      this.primaryIncomeData.map(d => total += d.amount)
      this.additionalIncomeData.map(d => total += d.amount)
      total -= this.wealthTransfers.totalMin
      total -= this.poc
      return total
    },
    primaryIncomeData() {
      let arr = []
      if(this.intake && this.intake.mainIncomes) {
        this.intake.mainIncomes.forEach(i => {
          if(i.amount && i.amount != '') {
            arr.push({
              label: i.name,
              amount: Math.round(parseFloat( (i.amount + '').replace(/[^0-9.]/,'')) ,2),
              credit: true
            })
          }
        })
      }
      return arr
    },
    additionalIncomeData() {
      let arr = []
      if(this.intake && this.intake.incomes) {
        this.intake.incomes.forEach(i => {
          if(i.amount && i.amount != '') {
            arr.push({
              label: i.name,
              amount: Math.round(parseFloat( (i.amount + '').replace(/[^0-9.]/,'')) ,2),
              credit: true
            })
          }
        })
      }
      return arr
    },
    wealthTransfers() {
      let total = 0
      let totalMin = 0
      let debts = []
      if(!this.household || !this.household.debts) {
        return { total: 0.00, totalMin: 0.00, data: []}
      }
      for(let i = 0; i < this.household.debts.length; i++) {
        let debt = this.household.debts[i]
        //if(debt.actual_payment && debt.minimum_payment && debt.actual_payment > debt.minimum_payment) {
        if(debt.minimum_payment) totalMin += parseFloat(debt.minimum_payment)
        if(debt.actual_payment && debt.minimum_payment) {
          let aPmt = parseFloat(debt.actual_payment)
          let mPmt = parseFloat(debt.minimum_payment)
          if(aPmt > mPmt) {
            debts.push(debt)
            total += aPmt - mPmt
          }
        }
      }
      return {
        total: Math.round(total, 2),
        totalMin: Math.round(totalMin, 2),
        data: debts
      }
    },
    lifeInsurances() {
      let total = 0
      let insurances = []
      if(!this.intake || !this.intake.insurances) {
        return { total: 0.00, data: []}
      }
      for(let i = 0; i < this.intake.insurances.length; i++) {
        let ins = this.intake.insurances[i]
        if(ins.owner && ins.type && ins.monthly_premium > 0) {
          if(ins.owner == 'user') ins.owner = this.household.user
          if(ins.owner == 'spouse') ins.owner = this.household.spouse

          insurances.push(ins)
          if(!ins.exclude) total += parseFloat(ins.monthly_premium)
        }
      }
      return {
        total: Math.round(total, 2),
        data: insurances
      }
    },
    retirementAccounts () {
      let total = 0
      let accounts = []
      if(!this.intake || !this.intake.retirements) {
        return { total: 0.00, data: []}
      }
      for(let i = 0; i < this.intake.retirements.length; i++) {
        let account = this.intake.retirements[i]
        let contribution = account.monthly_contribution
        let unmatched_contribution = contribution
        /*if(account.type == '401k' && account.employer_matchback && account.employer_matchback_percent && account.salary) {
          let total_matchback = account.salary * (account.employer_matchback_percent / 100) / 12
          if(total_matchback >= contribution) unmatched_contribution = 0
          if(contribution > total_matchback) {
            unmatched_contribution = parseFloat(contribution) - parseFloat(total_matchback)
          }
        }*/
        if(account.type == '401k' && account.employer_matchback_amount && !isNaN(account.employer_matchback_amount)) {
          unmatched_contribution = contribution - account.employer_matchback_amount 
        }

        if(account.owner && account.type && unmatched_contribution) {
          if(account.owner == 'user') account.owner = this.household.user
          if(account.owner == 'spouse') account.owner = this.household.spouse
          account.unmatched_contribution = Math.round(unmatched_contribution, 2)

          accounts.push(account)
          if(!account.exclude) total += parseFloat(unmatched_contribution)
        }
      }
      return {
        total: Math.round(total, 2),
        data: accounts
      }
    },
    savingsAccounts () {
      let total = 0
      let accounts = []
      if(!this.intake || !this.intake.savings) {
        return { total: 0.00, data: []}
      }
      for(let i = 0; i < this.intake.savings.length; i++) {
        let account = this.intake.savings[i]

        if(account.owner && account.type == 'savings' && account.monthly_contribution > 0) {
          if(account.owner == 'user') account.owner = this.household.user
          if(account.owner == 'spouse') account.owner = this.household.spouse

          accounts.push(account)
          if(!account.exclude) total += parseFloat(account.monthly_contribution)
        }
      }
      return {
        total: Math.round(total, 2),
        data: accounts
      }
    }
  },
  methods: {
    dontSave() {
      this.intake = JSON.parse(JSON.stringify(this.household.intake))
      this.$emit('on-close')
    },
    saveIntake () {
      this.saving = true
      let intakeData = this.household.intake
      for(let i = 0; i < intakeData.insurances.length; i++) {
        let iInsurance = intakeData.insurances[i]
        for(let i2 = 0; i2 < this.lifeInsurances.data.length; i2++) {
          let i2Insurance = this.lifeInsurances.data[i2]
          if(iInsurance.id && iInsurance.id == i2Insurance.id) {
            intakeData.insurances[i].exclude = i2Insurance.exclude
          }
        }
      }
      for(let i = 0; i < intakeData.retirements.length; i++) {
        let iRetirement = intakeData.retirements[i]
        for(let i2 = 0; i2 < this.retirementAccounts.data.length; i2++) {
          let i2Retirement = this.retirementAccounts.data[i2]
          if(iRetirement.id && iRetirement.id == i2Retirement.id) {
            intakeData.retirements[i].exclude = i2Retirement.exclude
            intakeData.retirements[i].unmatched_contribution = i2Retirement.unmatched_contribution
          }
        }
      }
      for(let i = 0; i < intakeData.savings.length; i++) {
        let iSavings = intakeData.savings[i]
        for(let i2 = 0; i2 < this.savingsAccounts.data.length; i2++) {
          let i2Savings = this.savingsAccounts.data[i2]
          if(iSavings.id && iSavings.id == i2Savings.id) {
            intakeData.savings[i].exclude = i2Savings.exclude
          }
        }
      }

      let data = {
        desired_monthly_cap: Math.round(this.poc),
        intake: intakeData
      }
      this.$http.put('households/' + this.household.id, data)
        .then(response => {
          this.$emit('on-save',response.data)
          //let query = JSON.parse(JSON.stringify(this.$route.query))
          //if(query.showSummary) {
          //  delete query.showSummary
          //  this.$router.replace({query:query})
         // }
        })
        .catch(err => {
          console.log(err.response)
          this.$swal.fire('Error', 'There was an error updating the household', 'error')
        })
        .finally(() => {
          this.saving = false
        })
    },
    setExclude (type, id, exclude) {
      if(type == 'retirement') {
        for(let i = 0; i < this.intake.retirements.length; i++) {
          if(this.intake.retirements[i].id == id) this.$set(this.intake.retirements[i], 'exclude', exclude)
        }
      }

      if(type == 'insurance') {
        for(let i = 0; i < this.intake.insurances.length; i++) {
          if(this.intake.insurances[i].id == id) this.$set(this.intake.insurances[i], 'exclude', exclude)
        }
      }

      if(type == 'savings') {
        for(let i = 0; i < this.intake.savings.length; i++) {
          if(this.intake.savings[i].id == id) this.$set(this.intake.savings[i], 'exclude', exclude)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .summaryFooter {
    height: 50px !important;
  }
</style>